import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UseFormReturn, FieldValues, FieldPath } from 'react-hook-form';

import {
    FormControl,
    FormControlStack,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from 'src/registry/ui/Form';
import { Switch } from 'src/registry/ui/Switch';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';

type SwitchFormFieldProps<TData extends FieldValues> = {
    form: UseFormReturn<TData>;
    name: FieldPath<TData>;
    label: string;
    disabled?: boolean;
    tooltip?: string;
    description?: string;
};

export default function SwitchFormField<TData extends FieldValues>({
    name,
    label,
    form,
    disabled,
    tooltip,
    description,
}: SwitchFormFieldProps<TData>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => {
                return (
                    <FormItem variant="dialog">
                        <FormControlStack className="flex-row justify-between">
                            <div className="max-w-3/4 flex-col">
                                <div className="flex">
                                    <FormLabel variant="default">{label}</FormLabel>
                                    {tooltip && (
                                        <TooltipProvider>
                                            <Tooltip>
                                                <TooltipTrigger type="button" className="mb-0 ml-1 text-gray-400">
                                                    <FontAwesomeIcon icon={faCircleQuestion} />
                                                </TooltipTrigger>
                                                <TooltipContent className="max-w-md">{tooltip}</TooltipContent>
                                            </Tooltip>
                                        </TooltipProvider>
                                    )}
                                </div>
                                {description && <FormDescription>{description}</FormDescription>}
                                <FormMessage />
                            </div>
                            <FormControl>
                                <Switch
                                    {...field}
                                    disabled={disabled}
                                    checked={field.value}
                                    onCheckedChange={field.onChange}
                                />
                            </FormControl>
                        </FormControlStack>
                    </FormItem>
                );
            }}
        />
    );
}
